module.exports = __webpack_public_path__ + "img/spotify-web2.c17868a3.png";